module.exports = __webpack_public_path__ + "vc.svg?9b9d4796590525ca0d73708919a3f5e2";